import { Action } from "./Action.js";
export { singleton as OTRS };
const NAME = "Поддержка";
const ICON = "chat";
const URL = "https://otrs.roweb.online/extauth/customer?lang=ru-RU";
const LOGOUT = "https://roweb.online/Personal/ru-RU/Home/Logout";
//const MUSE_AUTH = "https://muse.roweb.online/student/roweb_auth.php";
const OTRS_AUTH = "https://otrs.roweb.online/extauth/customer?lang=ru-RU";
const CUSTOMER = "https://otrs.roweb.online/otrs/customer.pl";
/**
 * Поддерживается интеграция со службой поддержки OTRS.
 * 
 * При нажатии на кнопку "Поддержка" создаётся новая заявка
 * с автоматически заполненными данными.
 * 
 * По умолчанию заполняется ссылка на страницу,
 * на которой у студента возникли проблемы.
 * 
 * В URL обычно присутствует идентификатор занятия или сессии,
 * что упрощает работу по поддержке студентов.
 * 
 * Программист при необходимости может добавить дополнительные данные
 * для автоматического заполнения на отдельных страницах, например,
 * текст сообщения об ошибке.
 * 
 * Для проверки работы модуля необходимо:
 * 1. [Авторизоваться в Личной студии][personal]
 * 2. [Открыть тестовую страницу][otrs]
 * 3. Нажать кнопку "Поддержка" (иконка "Чат": вторая справа, сверху)
 * 
 * [personal]: https://roweb.online/personal
 * [otrs]: https://muse.roweb.online/new-react-app/v24.2.19/#frame
 *  
 * @summary Модуль интеграции с OTRS.
 * @property {string} subject - Тема заявки в OTRS.
 * @property {string} body - Текст заявки для автозаполнения.
 * @property {EventListener} onClick - Открывает Поддержку.
 * @property {Action} OPEN - Пункт меню "Поддержка".
 * @see {@link ../service/ErrataView.jsx} как пример использования.
 * @see {@link EventListener.js}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class OTRS {
  constructor() {
    const thisOTRS = this;
    this.subject = "";
    this.body = "<br><br>";
    this.href = location.href;
    this.onClick = (event) => {
      event.preventDefault();
      thisOTRS.open();
    };
    this.OPEN = new Action(
      {
        name: NAME,
        icon: ICON,
        href: URL,
        target: "_blank",
        onClick: this.onClick
      });
  }
  /** 
   * Создаёт новую заявку.
   * @returns {Window} Окно с новой заявкой.
   */
  async open() {
    const auth =
      document.cookie.includes("StudyContractID=") ?
        "OK" : "Unauthorized";
    //    let auth;
    //    try {
    //      auth = await fetch(MUSE_AUTH);
    //      auth = await auth.text();
    //    }
    //    catch (e) {
    //      auth = e.message;
    //    }
    if ("OK" == auth) {
      const dialog = window.open(OTRS_AUTH, "OTRS");
      const href = CUSTOMER +
        "?Action=CustomerTicketMessage"
        + "&Subject=" + encodeURIComponent(this.subject)
        + "&Body=" + encodeURIComponent(this.body
          + "<br><hr>Ссылка на страницу с проблемой: " + this.href);
      setTimeout(() => { dialog.location.href = href }, 5000);
      return dialog;
    }
    else {
      return window.open(LOGOUT, "OTRS");
    }
  }

  /**
   * Функция обработки событий DOM.
   * @callback EventHandler
   * @pa
   * @see https://developer.mozilla.org/ru/docs/Web/API/Event
   */
}
const singleton = new OTRS;
